// extracted by mini-css-extract-plugin
export default {"btn":"SecondaryBtn_btn__64+tQ"};